import {useState} from 'react'

import Style from './style'
import StoreTicket from './ui/StoreTicket'
import SeedTicket from './ui/SeedTicket'
import ParticipationTicket from './ui/ParticipationTicket'
import QualificationSelect from './ui/QualificationSelect'

import MainHeader from 'widget/MainHeader'

import useGetAccountDetail from 'entity/account/useGetAccountDetail'
import usePutAccountBan from 'entity/account/usePostAccountBan'
import useDeleteAccountBan from 'entity/account/useDeleteAccountBan'

import DTStyle from 'shared/style/detailTableStyle'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import timestampCalculator from 'shared/lib/timestampCalculator'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import {
	ROLE_COMPETITION_MANAGER,
	ROLE_SUPER_ADMIN,
} from 'shared/constant/lookup/role'

/**
 * @Desc 유저상세 페이지
 * @Access 최고관리자 프로자격 기능추가(2025.08.31)
 */
const UserDetail = () => {
	const [userData] = useGetAccountDetail()
	const [banUser] = usePutAccountBan()
	const [unbanUser] = useDeleteAccountBan()

	const [roleCookie] = useRoleCookie()
	const [, setConfrimEvent] = useConfirmModalAtom()
	const btnList = []
	roleCookie === ROLE_SUPER_ADMIN &&
		btnList.push({
			label: userData?.data?.is_ban ? '정지 해지' : '정지',
			clickEvent: () => {
				userData?.data?.is_ban
					? setConfrimEvent(
							'해당 사용자의 정지를 해지하시겠습니까?',
							() => unbanUser
						)
					: setConfrimEvent(
							'해당 사용자가 더 이상 로그인을 할 수 없게 됩니다.\n정말 정지하시겠습니까?',
							() => banUser
						)
			},
			deactive: false,
		})

	const userDataList = [
		{
			label: 'IDX',
			value: userData?.data?.idx,
		},
		{
			label: '아이디',
			value: userData?.data?.id || '-',
		},
		{
			label: '이름',
			value: userData?.data?.name,
		},
		{
			label: '닉네임',
			value: userData?.data?.nickname,
		},
		{
			label: '연락처',
			value: `+${userData?.data?.international_number} ${userData?.data?.contact}`,
		},
		{
			label: '프로 자격',
			value:
				convertProGradeAsName[userData?.data?.pro_grade_flag] ||
				userData?.data?.qualification_name,
		},
		{
			label: '상태',
			value: userData?.data?.is_ban ? '정지' : '정상',
		},
		{
			label: '프리미엄',
			value: userData?.data?.is_premium ? '활성' : '미활성',
		},
		{
			label: '가입 날짜',
			value: timestampCalculator(userData?.data?.created_at),
		},
	]
	const profileImg = userData?.data?.profile_img

	const adminTabList = ['매장 이용권', '시드권', '참가권']
	const completionTabList = ['시드권', '참가권']

	const tabList =
		roleCookie === ROLE_COMPETITION_MANAGER ? completionTabList : adminTabList

	const [tab, setTab] = useState(tabList[0])

	return (
		<Style.Wrapper>
			<MainHeader btnList={btnList} />
			<Style.AreaDiv>
				<h2>사용자 계정 데이터</h2>
				<DTStyle.TableUserDetail>
					{userDataList?.map((elem, index) => (
						<DTStyle.TableElementUserDetail key={index}>
							<h2>{elem?.label}</h2>
							<p>{elem?.value}</p>
						</DTStyle.TableElementUserDetail>
					))}
				</DTStyle.TableUserDetail>
			</Style.AreaDiv>

			{roleCookie === ROLE_SUPER_ADMIN && (
				<Style.QualificationGrid>
					{userData?.data?.qualifications?.map((e, i) => {
						return <QualificationSelect key={i} data={e} />
					})}
				</Style.QualificationGrid>
			)}

			{profileImg && (
				<Style.AreaDiv>
					<h2>프로필 이미지</h2>
					<div>
						<Style.LogoImg src={profileImg} />
					</div>
				</Style.AreaDiv>
			)}

			<Style.TabDiv>
				{tabList.map((elem, index) => (
					<Style.Tab
						key={index}
						$selected={tab === elem}
						onClick={() => setTab(elem)}
					>
						{elem}
					</Style.Tab>
				))}
			</Style.TabDiv>

			{roleCookie === ROLE_COMPETITION_MANAGER ? (
				<>
					{tab === tabList[0] && <SeedTicket />}
					{tab === tabList[1] && <ParticipationTicket />}
				</>
			) : (
				<>
					{tab === tabList[0] && <StoreTicket />}
					{tab === tabList[1] && <SeedTicket />}
					{tab === tabList[2] && <ParticipationTicket />}
				</>
			)}
		</Style.Wrapper>
	)
}

export default UserDetail
